/**
 * Cache das conexões WhatsApp do utilizador autenticado.
 * Usado para ignorar eventos WS de caixas alheias (isolamento admin ↔ revenda).
 */
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';

let cache = { at: 0, ids: new Set() };
const TTL_MS = 60_000;

export function invalidateOwnedConnectionCache() {
  cache = { at: 0, ids: new Set() };
}

export async function loadOwnedConnectionIds(force = false) {
  const now = Date.now();
  if (!force && cache.at && now - cache.at < TTL_MS && cache.ids.size >= 0) {
    return cache.ids;
  }
  try {
    const { data } = await axios.get(`${API_BASE_URL}/api/connections`, {
      withCredentials: true,
      timeout: 15000,
    });
    const ids = new Set();
    (Array.isArray(data) ? data : []).forEach((c) => {
      const id = String(c?.id || '').trim();
      const inst = String(c?.instance_name || '').trim();
      if (id) ids.add(id);
      if (inst) ids.add(inst);
    });
    cache = { at: now, ids };
    return ids;
  } catch {
    // Em falha, mantém cache anterior (não abre o filtro a tudo)
    if (cache.at) return cache.ids;
    cache = { at: now, ids: new Set() };
    return cache.ids;
  }
}

/** true = evento pode ser mostrado; false = descartar (caixa alheia). */
export function isOwnedConnectionEvent(data, ownedIds) {
  if (!data || typeof data !== 'object') return false;
  const cid = String(
    data.connection_id ||
      data.connectionId ||
      data.message?.connection_id ||
      '',
  ).trim();
  // Sem connection_id: só permitir eventos não-chat (office_notify / attendance)
  const t = String(data.type || '');
  if (!cid) {
    return t === 'office_notify' || t === 'attendance_updated' || t === 'pong';
  }
  if (!(ownedIds instanceof Set) || ownedIds.size === 0) {
    // Ainda a carregar: rejeitar chats com connection_id (fail-closed)
    return t === 'office_notify' || t === 'attendance_updated' || t === 'pong';
  }
  return ownedIds.has(cid);
}
